<template>
  <div class="table-wrapper">
    <h3 v-if="config.series">{{ config.series }}</h3>

    <table class="data-table">
      <thead>
        <tr>
          <th v-for="col in config.columns" :key="col.key">
            {{ col.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in config.rows" :key="rowIndex">
          <td v-for="col in config.columns" :key="col.key">
            {{ row[col.key] || '-' }}
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="config.note" class="table-note">
      <small>Note: {{ config.note }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenericTable',
  props: {
    // 接收之前整理的 JSON 数据格式
    config: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.table-wrapper {
  margin: 20px 0;
  overflow-x: auto;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  font-size: 14px;
}
.data-table th,
.data-table td {
  border: 1px solid #dcdfe6;
  padding: 10px;
  text-align: center;
}
.data-table th {
  background-color: #f5f7fa;
  font-weight: bold;
}
.table-note {
  margin-top: 10px;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/page/Products/PTab.vue